/**
 * Product card quick add
 * @see https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js
 */
(function () {
  if (window.__productCardQuickAddBound) return;
  window.__productCardQuickAddBound = true;

  function getCartAddUrl() {
    if (window.routes?.cart_add_url) return window.routes.cart_add_url;
    const root = window.Shopify?.routes?.root || '/';
    return `${root}${root.endsWith('/') ? '' : '/'}cart/add`;
  }

  function renderCartSections(sections) {
    if (!sections) return;

    Object.entries(sections).forEach(([sectionId, sectionHTML]) => {
      const target = document.getElementById(sectionId);
      if (!target || !sectionHTML) return;

      const html = new DOMParser().parseFromString(sectionHTML, 'text/html');
      const source = html.querySelector('.shopify-section') || html.body;
      target.innerHTML = source.innerHTML;
    });
  }

  function setLoadingState(card, button, isLoading) {
    const overlay = card?.querySelector('.loading-overlay');

    if (!button) return;

    if (isLoading) {
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('disabled', 'disabled');
      button.classList.add('loading');
      if (overlay) {
        overlay.classList.remove('hidden');
        overlay.setAttribute('aria-hidden', 'false');
      }
      return;
    }

    button.classList.remove('loading');
    button.removeAttribute('aria-disabled');
    button.removeAttribute('disabled');
    if (overlay) {
      overlay.classList.add('hidden');
      overlay.setAttribute('aria-hidden', 'true');
    }
  }

  function setAddedState(button, originalText) {
    if (!button) return;

    const inner = button.querySelector('.btn-inner');
    if (inner) inner.textContent = 'Added';
  }

  function resetButtonState(button, originalText) {
    if (!button) return;

    const inner = button.querySelector('.btn-inner');
    if (inner && originalText) inner.innerHTML = originalText;
  }

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target.closest('form.product-card__quick-add-form');
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();

      const button = form.querySelector('.quick-add-to-cart__button');
      const idInput = form.querySelector('[name="id"]');

      if (!button || !idInput?.value || button.classList.contains('loading')) return;

      const card = form.closest('.product-card');
      const originalText = button.querySelector('.btn-inner')?.innerHTML || '';

      setLoadingState(card, button, true);

      const sections = ['cart-icon-bubble'];
      if (document.getElementById('cart-live-region-text')) {
        sections.push('cart-live-region-text');
      }

      const formData = new FormData(form);
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);

      const config =
        typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : {
              method: 'POST',
              headers: {
                Accept: 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest',
              },
            };

      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(getCartAddUrl(), config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            throw new Error(response.description || response.message || 'Cart error');
          }

          renderCartSections(response.sections);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add-to-cart',
              cartData: response,
              variantId: idInput.value,
            });
          }

          setLoadingState(card, button, false);
          setAddedState(button, originalText);
          if (card) card.classList.add('product-card--is-added');

          setTimeout(function () {
            resetButtonState(button, originalText);
            if (card) card.classList.remove('product-card--is-added');
          }, 1500);
        })
        .catch(function (error) {
          console.error(error);
          setLoadingState(card, button, false);
          resetButtonState(button, originalText);
          if (card) card.classList.remove('product-card--is-added');
        });
    },
    true
  );
})();
